module.exports = "<div class=\"container feature-list\">\n    <row-header *ngIf=\"showHeader\" [fullCopy]=\"true\" [row$]=\"list | meta\" class=\"featured\" [showCount]=\"true\"></row-header>\n    <feature-item *ngIf=\"getMarqueeItem(); let marquee\" [item]=\"marquee\"></feature-item>\n    <div class=\"row feature-carousel\">\n        <carousel-row [items]=\"getData()\" [config]=\"carouselConfig\"></carousel-row>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/feature-list/feature-list/feature-list.template.html
// module id = 779
// module chunks = 2